// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"booking-confirmation_wrapper__unPks","content":"booking-confirmation_content__2tSGM"};